import { useTranslation } from "react-i18next";
import { resolveDisplayName } from "../../../common/util/displayName";
import defaultContent from "../../../content/common";
import "./ABOName.scss";

type Props = {
  name: string;
  localName: string;
  privacyFlag: boolean | null | undefined;
  aboNo?: string;
  languageCode: string;
  locale: string;
  fontSize?: "small" | "normal" | "medium" | "big" | "huge" | "large";
  fontWeight?: "thin" | "regular" | "medium" | "bold";
};

const ABOName = (props: Props) => {
  const { name, localName, privacyFlag, languageCode, aboNo, fontSize, fontWeight, locale = "en-US" } = props;
  const { t } = useTranslation(["common"]);

  // Get translated strings
  const confidentialText = t("confidentialUser", defaultContent["confidentialUser"]) as string;
  const notAvailableText = t("notAvailable", defaultContent["notAvailable"]) as string;

  // Use the unified function with translated strings
  const displayName = resolveDisplayName({
    name,
    localName,
    privacyFlag,
    languageCode,
    locale,
    confidentialText,
    notAvailableText,
  });

  // Don't append ABO number if the display name is "Confidential User"
  const shouldShowAboNumber = aboNo && displayName !== confidentialText;

  // Append ABO number only if it's not a confidential user
  const fullDisplayName = shouldShowAboNumber ? `${displayName} #${aboNo}` : displayName;

  return (
    <span className={`${fontSize ? `abo-name--${fontSize} ` : ""}${fontWeight ? `abo-name--${fontWeight}` : ""}`}>
      {fullDisplayName}
    </span>
  );
};

export default ABOName;
